import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'dialog-component';
import DialogContent from 'dialog-content-component';
import Button from 'button-component';

const GDPRDialog = ({
    onHidden,
    countryCode
}) => {
    const location = (countryCode)
        ? `country code ${countryCode}`
        : 'your country';

    return (
        <Dialog
            className="GDPRDialog"
            onHidden={onHidden}
            closeOnShimClick={false}
            showClose={false}
        >
            <DialogContent>
                <h3>SpotHero is not currently available in {location}.</h3>
                <p>We don't have parking in your area, but we do have over 5,000 garages across the US and Canada if you're ever in need of a spot!</p>
                <Button
                    color="primary"
                    onClick={onHidden}
                >
                    Continue Anyway
                </Button>
            </DialogContent>
        </Dialog>
    );
};

GDPRDialog.propTypes = {
    onHidden: PropTypes.func.isRequired,
    countryCode: PropTypes.string
};

export default GDPRDialog;



// WEBPACK FOOTER //
// ./spothero/static/main/js/global/components/common/utils/GDPRDialog.jsx